import { render, staticRenderFns } from "./StockUsedLabel.vue?vue&type=template&id=c7769b50&scoped=true&"
import script from "./StockUsedLabel.vue?vue&type=script&lang=js&"
export * from "./StockUsedLabel.vue?vue&type=script&lang=js&"
import style0 from "./StockUsedLabel.vue?vue&type=style&index=0&id=c7769b50&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7769b50",
  null
  
)

export default component.exports